/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Button, Flex, Form, Input, Splitter, Tooltip } from 'antd';
import Modal from 'components/modal';
import { authProfile } from 'redux/auth/selectors';
import GoogleMap from 'routes/app/zone/components/map/GoogleMap';
import Card from 'components/card';
import {
  getGeoJSONEncoded,
  Point,
  useCreateZone,
  useZones,
} from 'services/ZoneService';
import { InfoCircleOutlined } from '@ant-design/icons';
import useUserCityPosition from 'hooks/useUserCity';
import { ZipCodeSelector } from './components/zipCodeSelector';

const { TextArea } = Input;

const ZoneAdd = () => {
  const history = useHistory();
  const profile = useSelector(authProfile);
  const { lat, lng } = useUserCityPosition();
  const {
    zones: { data: zones, isSuccess, isLoading, isFetching },
  } = useZones();
  const { mutate: createZone } = useCreateZone();

  const [polygon, setPolygon] = useState<Point[]>();
  const [name, setName] = useState<string>();
  const [detail, setDetail] = useState<string>();
  const [interurbanId, setInterurbanId] = useState<string>();
  const [open, setOpen] = useState(false);
  const [zipCodes, setZipCodes] = useState<string[]>([]);

  if (!isSuccess) return history.push('/zones');

  const handleSubmit = () => {
    const tenant = profile?.tenantId;
    const logisticOperatorId = profile?.logisticOperatorID;

    const zone = {
      name,
      detail,
      cdcId: interurbanId,
      tenant,
      logisticOperatorId,
      zipCodes,
      geoJson: getGeoJSONEncoded(polygon),
    };

    createZone(zone);
    history.goBack();
  };

  return (
    <div style={{ maxHeight: '80vh' }}>
      <Modal
        title={`¿Confirmar creación de zona ${name}?`}
        okText="Confirmar"
        cancelText="Volver"
        onOk={handleSubmit}
        onCancel={() => setOpen(false)}
        open={open}
      />
      <Splitter style={{ height: '83vh' }}>
        <Splitter.Panel
          style={{
            scrollbarGutter: 'stable',
            scrollbarColor: 'lightgrey transparent',
            overflowX: 'hidden',
          }}
        >
          <Flex
            vertical
            style={{
              padding: '0 4px 0 0',
              height: '100%',
            }}
          >
            <Card title="Datos de la zona">
              <label>Nombre:</label>
              <Form.Item validateStatus="warning">
                <Input
                  placeholder="Nombre"
                  onBlur={(event) => setName(event.target.value)}
                  onPressEnter={({ target }) => {
                    setName((target as HTMLInputElement).value);
                  }}
                />
              </Form.Item>
              <label>Descripción:</label>
              <Form.Item validateStatus="warning">
                <TextArea
                  rows={3}
                  placeholder="Informacion adicional de esa zona"
                  onBlur={(event) => setDetail(event.target.value)}
                  onPressEnter={({ target }) => {
                    setDetail((target as HTMLInputElement).value);
                  }}
                />
              </Form.Item>
              <label>Identificador inter-urbano:</label>
              <Form.Item>
                <Input
                  placeholder="Número de identificación"
                  onBlur={(event) => setInterurbanId(event.target.value)}
                  onPressEnter={({ target }) => {
                    setInterurbanId((target as HTMLInputElement).value);
                  }}
                  suffix={
                    <Tooltip title="El identificador de inter-urbano es un número necesario para el cálculo de las tarifas inter-urbano, entre ciudades, o también llamadas troncales.">
                      <InfoCircleOutlined
                        style={{ color: 'rgba(0,0,0,.45)' }}
                      />
                    </Tooltip>
                  }
                />
              </Form.Item>
            </Card>
            <ZipCodeSelector
              selectedZipCodes={zipCodes}
              setZipCodes={setZipCodes}
            />
          </Flex>
        </Splitter.Panel>
        <Splitter.Panel defaultSize="70%" min="50%" max="80%">
          <div style={{ width: '100%', height: '100%', padding: '0 0 0 14px' }}>
            <GoogleMap
              arePolygonsLoading={isLoading || isFetching}
              initialCenter={{
                lat: lat ?? -34.601692,
                lng: lng ?? -58.431461,
              }}
              isAddZone
              onPolygonChange={(p) => setPolygon(p)}
              polygons={zones}
            />
          </div>
        </Splitter.Panel>
      </Splitter>
      <Button
        type="primary"
        onClick={() => setOpen(true)}
        disabled={
          !polygon || (!!polygon && !polygon.length) || !name || !detail
        }
        size="large"
        style={{
          position: 'absolute',
          bottom: 0,
          right: 0,
          marginRight: 80,
          marginBottom: 40,
        }}
      >
        Crear nueva Zona
      </Button>
    </div>
  );
};

export default ZoneAdd;
